<template>
  <a class="wave-image-block"
     :class="{wave_block_green: is_green}"
    :href="href">
    <div class="wave-image-block__content position-relative">
      <div
        :class="priority_on_sub_title ? 'wave-image-block__content-sub-title' : 'wave-image-block__content-title'">
        {{title}}
      </div>
      <div
        :class="priority_on_sub_title ? 'wave-image-block__content-title' : 'wave-image-block__content-sub-title'">
        {{sub_title}}
      </div>
      <div class="wave-image-block__content-layer-title">
        <arrow-text-hover
          :text="layer_text"
          item_block/>
      </div>
    </div>
  </a>
</template>

<script>

import {mapGetters} from "vuex";
import WaveNewIcon from "../../fill_svg/waves/WaveNewIcon.vue";
import ArrowTextHover from "../../small_parts/ArrowTextHover.vue";

export default {
  name: "WaveImageBlock",
  components: {
    ArrowTextHover,
    WaveNewIcon
  },
  props: {
    href: {
      type: String,
      default: '#',
    },
    image_lazy_src: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    sub_title: {
      type: String,
      default: '',
    },
    layer_text: {
      type: String,
      default: '',
    },
    wave_icon_index: {
      type: Number,
      default: 0,
    },
    priority_on_sub_title: {
      type: Boolean,
      default: false,
    },
    is_green: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
  }
}
</script>
